module.exports = __webpack_public_path__ + "img/colorwall.dd463904.svg";